import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import Admin from './components/Admin';
import AdminGate from './components/AdminGate';
import App from './components/App';
import TelegramPage from './components/TelegramPage';
import { ChakraProvider } from '@chakra-ui/react';
import AdminAuthProvider from './contexts/AdminAuthProvider';
import NewTeacherProvider from './contexts/NewTeacherProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  React.createElement(
    React.StrictMode,
    null,
    React.createElement(
      ChakraProvider,
      null,
      React.createElement(
        BrowserRouter,
        null,
        React.createElement(
          Routes,
          null,
          React.createElement(Route, {
            path: '/',
            element: React.createElement(NewTeacherProvider, null, React.createElement(App, null))
          }),
          React.createElement(Route, {
            path: '/:teacher_external_id/telegram',
            element: React.createElement(TelegramPage, null)
          }),
          React.createElement(Route, {
            path: '/admin',
            element: React.createElement(
              AdminAuthProvider,
              null,
              React.createElement(AdminGate, null, React.createElement(Admin, null))
            )
          })
        )
      )
    )
  )
);
